export default function (props: any) {
    return (
        <svg width="187" height="177" viewBox="0 0 187 177" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.3">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M57.5547 88.6758H182.306C188.764 88.6758 194 93.9115 194 100.37C194 101.476 193.843 102.575 193.535 103.637L174.824 167.956C173.371 172.949 168.795 176.383 163.595 176.383H91.8467C86.6462 176.383 82.0706 172.949 80.6179 167.956L57.5547 88.6758Z"
                    stroke="white"
                    strokeWidth="11.2"
                    strokeLinecap="round"
                />
                <path
                    d="M61.0825 100.371L54.5243 79.3466C53.0004 74.4617 48.4776 71.1348 43.3605 71.1348H25.9995"
                    stroke="white"
                    strokeWidth="11.2"
                    strokeLinecap="round"
                />
                <path d="M104.332 118.019V147.277" stroke="white" strokeWidth="11.2" strokeLinecap="round" />
                <path d="M127.721 118.019V147.277" stroke="white" strokeWidth="11.2" strokeLinecap="round" />
                <path d="M151.109 118.019V147.277" stroke="white" strokeWidth="11.2" strokeLinecap="round" />
                <rect x="130.527" y="51.1978" width="23.7692" height="3.57925" fill="white" stroke="white" strokeWidth="1.68" />
                <path d="M154.263 63.6981H133.92V68.1553V72.5956H130.527V63.6981V60.1357H154.263V63.6981Z" fill="white" stroke="white" strokeWidth="1.68" />
                <path d="M127.222 54.7326H103.453V51.1533H127.222V54.7326Z" fill="white" stroke="white" strokeWidth="1.68" />
                <path d="M127.189 63.6842H103.453V60.105H127.189V63.6842Z" fill="white" stroke="white" strokeWidth="1.68" />
                <path d="M127.189 69.0532V72.6325H103.453V69.0532H127.189Z" fill="white" stroke="white" strokeWidth="1.68" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M152.023 83.2652C157.455 77.3773 160.774 69.5096 160.774 60.8668C160.774 42.6193 145.981 27.8267 127.733 27.8267C109.486 27.8267 94.6934 42.6193 94.6934 60.8668C94.6934 69.5096 98.0119 77.3773 103.444 83.2652H92.1979C88.1031 76.7824 85.7333 69.1013 85.7333 60.8668C85.7333 37.6708 104.537 18.8667 127.733 18.8667C150.929 18.8667 169.734 37.6708 169.734 60.8668C169.734 69.1013 167.364 76.7824 163.269 83.2652H152.023ZM128.13 102.865H127.337C127.469 102.866 127.601 102.867 127.733 102.867C127.866 102.867 127.998 102.866 128.13 102.865Z"
                    fill="white"
                />
            </g>
        </svg>
    );
}
